import { useHistory } from "react-router-dom";

export default function BackButtonViewModel() {
  const history = useHistory();
  this.back = () => history.goBack();
}
